/* ==========================================================================
   Overlay de búsqueda: apertura desde la lupa, sugerencias por
   /search/suggest.json y cierre por X / Escape / clic fuera.
   ========================================================================== */

(function () {
  'use strict';

  var overlay = document.querySelector('[data-search]');
  if (!overlay) return;

  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-search-results]');
  var opener = null;
  var timer = null;
  var lastQuery = '';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function open(fromEl) {
    opener = fromEl || null;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    input.focus();
  }

  function close() {
    overlay.hidden = true;
    document.documentElement.style.overflow = '';
    if (opener) opener.focus();
  }

  function money(value) {
    var n = parseFloat(value);
    return isNaN(n) ? value : '$' + n.toFixed(2);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function render(query, products) {
    results.textContent = '';

    if (!products.length) {
      var template = results.getAttribute('data-no-results-template') || '%TERMS%';
      results.appendChild(el('p', 'gyaa-search-overlay__empty', template.replace('%TERMS%', query)));
      results.hidden = false;
      return;
    }

    products.forEach(function (p) {
      var item = el('a', 'gyaa-search-overlay__item');
      item.href = p.url;
      if (p.image) {
        var img = el('img', 'gyaa-search-overlay__thumb');
        img.src = p.image;
        img.alt = '';
        img.width = 44;
        img.height = 44;
        img.loading = 'lazy';
        item.appendChild(img);
      } else {
        item.appendChild(el('span', 'gyaa-search-overlay__thumb'));
      }
      item.appendChild(el('span', 'gyaa-search-overlay__item-title', p.title));
      item.appendChild(el('span', 'gyaa-search-overlay__item-price', money(p.price)));
      results.appendChild(item);
    });

    var all = el('a', 'gyaa-search-overlay__all', (results.getAttribute('data-view-all-label') || 'View all') + ' →');
    all.href = (results.getAttribute('data-search-url') || '/search') + '?q=' + encodeURIComponent(query);
    results.appendChild(all);
    results.hidden = false;
  }

  function suggest(query) {
    fetch(root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (query !== lastQuery) return; // llegó tarde
        var products = (((data.resources || {}).results || {}).products) || [];
        /* Fuera los productos portadores del handling fee (app Upcharge) */
        products = products.filter(function (p) { return p.type !== 'mws_fee_generated'; });
        render(query, products);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-search-open]');
    if (openBtn) {
      event.preventDefault();
      open(openBtn);
      return;
    }
    if (!overlay.hidden && event.target.closest('[data-search-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (overlay.hidden) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    // mini focus-trap: Tab circula dentro del panel
    if (event.key === 'Tab') {
      var focusables = overlay.querySelectorAll('input, button, a[href]');
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  input.addEventListener('input', function () {
    var query = input.value.trim();
    lastQuery = query;
    clearTimeout(timer);
    if (query.length < 2) {
      results.hidden = true;
      results.innerHTML = '';
      return;
    }
    timer = setTimeout(function () { suggest(query); }, 220);
  });
})();
